<template>
  <div class="technical-view">
    <section class="site-hero technical-hero">
      <div class="site-hero__inner">
        <span class="site-hero__eyebrow">Technical Style</span>
        <h1>技术现场展示</h1>
        <p>文本内容描述...</p>
      </div>
    </section>

    <section class="page-section content-section">
      <div class="page-head">
        <div><h2>现场图集</h2></div>
      </div>
      <div class="page-shell gallery-grid">
        <article v-for="item in technicalScenes" :key="item.title" class="scene-card panel-card">
          <img :src="item.image" :alt="item.title">
          <div class="scene-body">
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </div>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import { getSitePage } from "@/api/website";

export default {
  name: "TechnicalStyleView",
  data() {
    return {
      technicalScenes: []
    };
  },
  created() {
    getSitePage("technicalStyle").then((res) => {
      this.technicalScenes = (res.data && res.data.technicalScenes) || [];
    });
  }
};
</script>

<style lang="less" scoped>
.technical-hero {
  background:
    linear-gradient(90deg, rgba(3, 23, 50, 0.94) 0%, rgba(7, 55, 105, 0.74) 48%, rgba(12, 83, 146, 0.34) 100%),
    url("/assets/banner.png") center / cover no-repeat;
}

.content-section {
  background: var(--soft-blue);
}

.page-shell {
  width: min(1280px, 100%);
  margin: 0 auto;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.scene-card {
  overflow: hidden;
}

.scene-card img {
  width: 100%;
  aspect-ratio: 1 / 0.8;
  object-fit: cover;
}

.scene-body {
  padding: 22px;
}

.scene-body h3 {
  margin: 0 0 10px;
  font-size: 22px;
}

.scene-body p {
  margin: 0;
  color: var(--muted);
}

@media (max-width: 1040px) {
  .gallery-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 680px) {
  .scene-body {
    padding: 18px;
  }

  .scene-body h3 {
    font-size: 20px;
  }

  .scene-body p {
    font-size: 14px;
  }
}
</style>
